import { withModifiers } from '../../../helpers/withModifiers'
import styles from './styles.module.scss'
import { useModalContext } from '../../../../providers/modalProvider'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import Button from '../../../elements/Button'
import IconClose from '/public/icons/icon-modal-close.svg'
import { useRouter } from 'next/router'

const Modal = ({ translations }) => {
  const { show, variant, handleCloseModal, content } = useModalContext()
  const { isSmallMobile } = useResponsive()
  const isOutsideClose = !variant.includes('prevent-outside-close')
  const router = useRouter()

  return (
    <div
      className={withModifiers(
        'modal',
        [show && 'is-active', ...variant],
        styles
      )}
    >
      <div
        onClick={() => isOutsideClose && handleCloseModal()}
        className={styles.modal__offcanvas}
      ></div>
      <div className={styles.modal__content}>
        {content}

        <Button
          className={styles.modal__close}
          onClick={() => handleCloseModal()}
          variant={['label']}
          arrow={false}
          prepend={
            <IconClose
              width={isSmallMobile ? 15 : 9}
              height={isSmallMobile ? 15 : 9}
            />
          }
        >
          {!isSmallMobile && translations?.close?.[router.locale]}
        </Button>
      </div>
    </div>
  )
}

export default Modal
